<script>
  import { onDestroy, onMount } from "svelte";
  import {
    a,
    getashapes,
    getDisplayedShapes,
    getSelectedShapes,
  } from "../../../shared/globalState/a";
  import { drawShapes } from "../../../shared/render/shapes";
  import {
    selectedText$,
    textLinesCollection,
  } from "../../../libs/canvas-text/src/shared/state";
  import { rerender } from "../../../libs/canvas-text/src";
  import Autocompolete from "./Autocompolete.svelte";
  import { getElemComputedHeight } from "../../../shared/common";
  import { stored } from "../../stores/stores";

  // *** stores ***

  let setMode;
  let gm;

  const unsubscribe = stored.subscribe((v) => {
    setMode = v.setMode;
    gm = v.getMode;
  });
  onDestroy(unsubscribe);

  // *** lifecycle

  onMount(async function () {
    // подписка на события выбора фигур
    a.selected$.subscribe((v) => {
      selected = v;
      selectionChanged();
    });
    // подписка на события выбора текста
    selectedText$.subscribe((v) => {
      selectedText = v;
      selectionTextChanged(selectedText);
    });

    // записать высоту окна в css переменную чтобы следующее окно "Свойства" расположить прямо под ним
    let selectWindowHeight = getElemComputedHeight("#select-window");
    document.documentElement.style.setProperty(
      "--select-window-height",
      selectWindowHeight + "px",
    );
  });

  let selected = [];
  let selectedText = [];
  export let cl = "";

  /**
   * Реальный тип - это может быть стена или окно или дверь или труба или радиатор и так далее
   */
  let rtypes = [];
  let saved = [];

  function selectionChanged() {
    saved = [...new Set(getashapes().map((s) => s.rtype))];
    var selectedShapes = getSelectedShapes();
    if (selectedShapes.length > 0) {
      rtypes = [...new Set(selectedShapes.map((s) => s.rtype))];
    } else {
      rtypes = [];
    }
  }

  function selectionTextChanged(selected) {
    if (selected.length > 0) {
      rtypes.push(...new Set(selected.map((s) => s.rtype)));
    }
  }

  function assignRType(v) {
    getSelectedShapes().forEach((s) => (s.rtype = v));
    selectionChanged();
  }

  function assignTextRType(v) {
    // --- text
    textLinesCollection.filter((t) => t.selected).forEach((t) => (t.rtype = v));
    selectionTextChanged(selectedText);
    // --- text
  }

  function changeSelectionByRT(event) {
    let v = event.target.value;
    let newRT = rtypes.filter((s) => s !== v);

    getDisplayedShapes().forEach((s) => (s.isSelected = true));
    getDisplayedShapes()
      .filter((s) => newRT.includes(s.rtype))
      .forEach((s) => (s.isSelected = false));
    drawShapes();

    // --- text
    textLinesCollection.forEach((t) => (t.selected = true));
    textLinesCollection
      .filter((t) => newRT.includes(t.rtype))
      .forEach((t) => (t.selected = false));
    rerender();
    // --- text

    rtypes = newRT;

    let checkboxes = document.querySelectorAll(".props input[type=checkbox]");
    checkboxes.forEach((cb) => (cb.checked = false));
  }

  function handleAutocompolete(event) {
    assignRType(event.detail);
    assignTextRType(event.detail);
  }

  function handleMouseover(e) {
    a.blockUI = true;
  }

  function handleMouseout(e) {
    let elem = e.target;
    let inputs = elem.querySelectorAll("input");
    inputs.forEach((elem) => {
      elem.blur();
    });
    a.blockUI = false;
    setMode("select");
  }
</script>

<div
  class="props {cl}"
  id="select-window"
  on:mouseover={handleMouseover}
  on:mouseout={handleMouseout}
  role="toolbar"
  on:focus
  on:blur
  tabindex="-1"
>
  <h1>Окно выбора</h1>
  <hr />
  <div>
    <Autocompolete
      data={saved}
      placeholder="Укажите любой тип..."
      on:selected={handleAutocompolete}
    ></Autocompolete>
  </div>
  <div>
    {#each rtypes.map((rt) => (!rt ? "без типа" : rt)).sort() as rtype}
      <div>
        <input
          type="checkbox"
          name="rtype"
          value={rtype}
          on:change={changeSelectionByRT}
        />
        <label for={rtype}>{rtype}</label>
      </div>
    {/each}
  </div>
</div>

<style>
  h1 {
    font-size: large;
    font-weight: bold;
    text-align: center;
  }
  hr {
    margin-top: 0.25em;
    margin-bottom: 0.5em;
  }
  .props {
    border-radius: 5px;
    background-color: rgb(241 245 249 / 1);
    padding: 0.5em 1em;
    height: 28vh;
    margin-top: 0.5em;
  }
</style>
